import { useState } from "react"
import { useIsomorphicLayoutEffect } from "./useIsomorphicLayoutEffect"

const useMediaQuery = (query: string, defaultValue: boolean = false) => {
  const IS_SERVER = typeof window === "undefined"

  const getMatches = (query: string) => {
    return !IS_SERVER ? window.matchMedia(query).matches : defaultValue
  }

  const [matches, setMatches] = useState<boolean>(getMatches(query))

  const handleChange = () => {
    setMatches(getMatches(query))
  }

  useIsomorphicLayoutEffect(() => {
    const matchMedia = !IS_SERVER ? window.matchMedia(query) : undefined

    handleChange()

    if (matchMedia && matchMedia.addListener) {
      matchMedia.addListener(handleChange)
    } else if (matchMedia) {
      matchMedia.addEventListener("change", handleChange)
    }

    return () => {
      if (matchMedia && matchMedia.removeListener) {
        matchMedia.removeListener(handleChange)
      } else if (matchMedia) {
        matchMedia.removeEventListener("change", handleChange)
      }
    }
  }, [query])

  return matches
}

export default useMediaQuery
